export const CRUMB_LABEL_KEY = 'CorporateProfile';
export const NAME = 'CPFListIframe';
